import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        padding: 40,
    },
    header: {
        absolute: "fixed",
        top: 0,
        left: 0,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 16
    },
    headerLeft: {
        width: 40,
        height: 40,
    },
    headerImg: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    },
    headerCenter: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    headerRight: {
        width: 120,
        fontSize: 8,
        justifyContent: "flex-start"
    },
    headerRightText: {
        fontSize: 11,
        fontWeight: "semibold",
        marginBottom: 2
    },
    headerRightTextSmall: {
        fontSize: 10,
        fontWeight: "normal",
        color: "#6f6f6f"
    },
    titleCenter: {
        fontSize: 20,
        fontWeight: "normal",
        textAlign: "center"
    },
    line: {
        borderBottom: "2pt solid #cccccc",
        marginVertical: 16
    },
    blockTitle: {
        fontSize: 16,
        marginBottom: 8,
        fontWeight: "semibold"
    },
    keyValueContain: {
        display: "flex",
        flexDirection: "row",
        gap: 8,
        marginVertical: 4
    },
    key: {
        fontSize: 13,
        marginBottom: 2,
        fontWeight: "semibold"
    },
    value: {
        fontSize: 13,
        marginBottom: 2,
        fontWeight: "normal"
    },
    list: {
        marginLeft: 15,
    },
    listItem: {
        fontSize: 14,
        marginBottom: 4
    },
    table: {
        marginTop: 10,
        marginBottom: 10
    },
    tableRow: {
        flexDirection: "row"
    },
    tableHeaderCell: {
        flex: 1,
        padding: 6,
        fontSize: 11,
        backgroundColor: "#232d68",
        color: "white",
        fontWeight: "bold",
        textAlign: "center",
        border: "1pt solid white"
    },
    tableCell: {
        flex: 1,
        padding: 6,
        fontSize: 11,
        backgroundColor: "#eeeeee",
        color: "#000",
        textAlign: "center",
        border: "1pt solid white"
    },
    tableFooter: {
        textAlign: "center",
        fontSize: 9,
        marginTop: 6
    },
    footerContainer: {
        position: "absolute",
        bottom: 8,
        left: 0,
        right: 0,
        paddingHorizontal: 40,
        paddingTop: 20
    },
    footer: {
        textAlign: "center",
        fontSize: 9
    }
});

export default styles;

/* 
    Estilos para el documento PDF generado en el reporte de compliance report

    - Daniel Bonilla Septiembre 2025
*/